import nbrApi from "../../../../services/nbrApi";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getFloorName, getFloorNameNew, parseCartLocationResponse, showFloor, showRoom } from "../../../../services/common.utils";
import { BeatLoader } from "react-spinners";
import CircleButton from "../../common/CircleButton";
import MonitorDoorCardV2 from "../../../pages/Monitor/MonitorDoorCardV2";
import BottomMenu from "../BottomMenu";
import CartLocationManager from "../CartLocationManager";
import cartIcon from "../../../../images/guestInit.png";
import FunctionProgressBar from "./FunctionProgressContainer";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

/** Set to `true` to inject a mock process door when the API returns no next room (responsive / layout testing). Set back to `false` when done. */
const ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST = false;

const PROCESS_ROOM_CARD_TEST_NBR = {
    room_number: 405,
    from_room_number: 405,
    to_room_number: 405,
    room_type_code: "STNQ",
    room_type_name: "Standard Queen",
    status_display_text: "Request Accepted – In Transit",
    status_display_backcolor: "#50d479",
    status_display_forecolor: "#ffffff",
    status_display_inner_border_color: "#ffffff",
    status_display_outer_border_color: "#50d479",
    status_name: "request accepted - transit to room",
    service_status: "in_service",
    cart_resource_initials: "KL",
    occupied: 0,
    door_panel_blink_interval: 0,
    show_icon: 0,
    user_function_name: "Rooms cleaning 1",
};

function mergeProcessRoomCardTestPayload(apiData) {
    if (!ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST) return apiData;
    const base = apiData || {};
    const nbr = base.nbr;
    const missingRoom =
        !nbr || nbr.to_room_number == null || nbr.to_room_number === "" || String(nbr.to_room_number) === "null";
    if (!missingRoom) return apiData;
    const fts = base.function_time_segment || {};
    return {
        ...base,
        nbr: {
            ...PROCESS_ROOM_CARD_TEST_NBR,
            ...(nbr || {}),
            from_room_number: PROCESS_ROOM_CARD_TEST_NBR.from_room_number,
            to_room_number: PROCESS_ROOM_CARD_TEST_NBR.to_room_number,
            room_number: PROCESS_ROOM_CARD_TEST_NBR.room_number,
        },
        function_time_segment: {
            seconds_clean: fts.seconds_clean ?? 90,
            function_seconds_allocated: fts.function_seconds_allocated ?? 129,
            hkfunctiontimesegments_id: fts.hkfunctiontimesegments_id ?? 999001,
            ...fts,
        },
        user_function: {
            user_label: "Clean",
            hkfunctionrequests_id: base.user_function?.hkfunctionrequests_id ?? 0,
            room_number: String(PROCESS_ROOM_CARD_TEST_NBR.room_number),
            ...(base.user_function || {}),
        },
    };
}

const ProcessMode = ({ currentShift, setCurrentShift, nextSegment, setNextSegment, propertiesId, resourcesId, defaultRoomData = 801, ss_id = null, tcs_id = null, hksd_id = null,
    showMenu, setShowMenu
}) => {
    const navigate = useNavigate();
    const [isAccepted, setIsAccepted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(null);
    const [activeFunctionId, setActiveFunctionId] = useState(null);
    const [nextFunctionId, setNextFunctionId] = useState(null);
    const [roomData, setRoomData] = useState({
        fromRoom: '',
        toRoom: '',
        roomType: '',
        roomTypeName: '',
        userFunctionName: '',
        transitSeconds: 0,
        statusDisplayText: '',
        timeStart: null,
    });
    const [initData, setInitData] = useState({})
    const [startData, setStartData] = useState({})
    const [acceptedData, setAcceptedData] = useState({})
    const [isStarted, setIsStarted] = useState(false)
    const [hkfunctiontimesegments_id, setHkfunctiontimesegments_id] = useState(0)
    const [function_time_segment, setFunction_time_segment] = useState({})
    const userDetailsAll = JSON.parse(localStorage.getItem("userDetailsAll")) || {};
    let roleId = userDetailsAll?.session_info?.roles_id || null
    let roleName = userDetailsAll?.session_info?.role_name || null
    let nextShift = JSON.parse(localStorage.getItem("next_shift"));

    /** Session role on process payload so V2 cart/inspector footer matches the worker view. */
    const enrichProcessRoomData = (nbr) => {
        if (!nbr) return nbr;
        if (roleName === 'room inspector') {
            return {
                ...nbr,
                show_monitor_inspector_footer: true,
                show_icon: 1
            };
        }
        return nbr;
    };

    const renderProcessDoorCard = ({ data, roomNumber, status, statusColor, room_statuses }) => (
        <div className="d-flex justify-content-center my-3">
            <MonitorDoorCardV2
                data={enrichProcessRoomData(data)}
                roomNumber={roomNumber}
                status={status}
                statusColor={statusColor}
                isDnd={false}
                isProcessMode={true}
                room_statuses={room_statuses}
                mbb="mb-0"
            />
        </div>
    );

    // Cart Modal State
    const [showCartModal, setShowCartModal] = useState(false);
    const [cartLocation, setCartLocation] = useState("");
    const [selectedFloor, setSelectedFloor] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");
    const selectedLoginData = JSON.parse(localStorage.getItem('selectedLoginData')) || {};
    const selectedData = userDetailsAll?.user_info || {};
    const [ftsIdOut, setFtsIdOut] = useState(null);
    const [todayVariance, setTodayVariance] = useState(null);

    // Helper function to extract and set variance from API response
    const updateVarianceFromResponse = (responseData) => {
        console.log(responseData, 'rs')
        // Check multiple possible paths for variance
        const varianceValue = responseData?.user_function?.today_variance ?? 
                             responseData?.nbr?.user_function?.today_variance;
        
        if (varianceValue !== null && varianceValue !== undefined) {
            const variance = Number(varianceValue);
            setTodayVariance(isNaN(variance) ? null : variance);
        }
    };

    // Format variance for display (convert seconds to readable format)
    const formatVariance = (seconds) => {
        if (seconds === null || seconds === undefined) return '--';
        const absSeconds = Math.abs(seconds);
        const hours = Math.floor(absSeconds / 3600);
        const minutes = Math.floor((absSeconds % 3600) / 60);
        const secs = absSeconds % 60;
        
        let timeString = '';
        if (hours > 0) {
            timeString = `${hours}h ${minutes}m`;
        } else if (minutes > 0) {
            timeString = `${minutes}m${secs > 0 ? secs + 's' : ''}`;
        } else {
            timeString = `${secs}s`;
        }
        
        return timeString;
    };

    const handleAcceptRequest = async () => {
        setLoading(true);

        try {
            const response = await nbrApi.post("/respondtofunctionrequest", {
                properties_id: propertiesId,
                resources_id: resourcesId,
                hkfunctiontimesegments_id: hkfunctiontimesegments_id,
                "response": "accepted",
                "response_comments": initData?.user_function?.user_label || 'test comment',
                shiftsegments_id: Number(ss_id),
                timeclocksegments_id: tcs_id ? tcs_id : nextShift?.tcs_id_active,
                hkfunctionrequests_id: initData?.user_function?.hkfunctionrequests_id,
                roles_id: roleId,
                role_name: roleName,
                fts_id_out: ftsIdOut
            });

            const data = response?.data;
            setFunction_time_segment({ ...response?.data?.function_time_segment, seconds_clean: response?.data?.function_time_segment?.clean } || {})

            if (data) {
                if (data?.function_time_segment?.hkfunctiontimesegments_id) {
                    setHkfunctiontimesegments_id(data?.function_time_segment?.hkfunctiontimesegments_id)
                }

                setFtsIdOut(data?.function_time_segment?.hkfunctiontimesegments_id)
                setAcceptedData(data)
                setIsAccepted(true);
                setRoomData({ ...roomData, toRoom: data?.user_function?.user_label + ' ' + data?.user_function?.room_number })
                
                // Update variance from API response
                updateVarianceFromResponse(data);

            } else {
                toast.error("Failed to accept");
            }
        } catch (error) {
            toast.error("Failed to accept");
        } finally {
            setLoading(false);
        }
    };

    const getInitData = async (hkts_id = null) => {
        try {
            const response = await nbrApi.post("/requestnextroom", {
                properties_id: propertiesId,
                resources_id: resourcesId,
                shiftsegments_id: Number(ss_id),
                hkscheduledetails_id: hksd_id,
                timeclocksegments_id: tcs_id ? tcs_id : nextShift?.tcs_id_active,
                hkfunctiontimesegments_id: hkts_id ? hkts_id : hkfunctiontimesegments_id,
                roles_id: roleId,
                role_name: roleName
            });
            const merged = mergeProcessRoomCardTestPayload(response?.data);
            let resNbr = merged?.nbr;
            if (!resNbr?.to_room_number || resNbr?.to_room_number === 'null') {
                if (!ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST) {
                Swal.fire({
                    icon: 'info',
                    html: `<strong>No rooms available to ${roleName === "room inspector" ? "inspect" : "clean"}</strong>`,
                    showConfirmButton: true,
                    confirmButtonText: 'Retry',
                    showCancelButton: true,
                    cancelButtonText: roleName === 'room inspector' ? 'Stop Inspecting' : 'Stop Cleaning',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    backdrop: true,
                    didOpen: () => {
                        Swal.getConfirmButton().addEventListener('click', async () => {
                            Swal.showLoading();

                            try {
                                let shouldDismiss = await getInitData();
                                if (shouldDismiss) {
                                    Swal.close();
                                } else {
                                    Swal.hideLoading();
                                }
                            } catch (err) {
                                console.error(err);
                                Swal.hideLoading();
                            }
                        });

                        Swal.getCancelButton().addEventListener('click', () => {
                            Swal.close();
                            // Same exit path as "Stop Cleaning / Quit Inspection" after declining a request
                            openCartModal();
                        });
                    }
                });
                }
            }
            setInitData(merged);
            setFunction_time_segment(merged?.function_time_segment || {});

            if (merged) {
                setIsStarted(false);
                setIsAccepted(false);
                setHkfunctiontimesegments_id(merged?.function_time_segment?.hkfunctiontimesegments_id);
                setFtsIdOut(merged?.function_time_segment?.hkfunctiontimesegments_id);
            }
            const data = merged?.nbr;
            if (data && data.from_room_number != null && data.to_room_number != null) {
                setRoomData({
                    fromRoom: Number(data.from_room_number),
                    toRoom: Number(data.to_room_number),
                    roomType: data.room_type_code,
                    roomTypeName: data.room_type_name,
                    userFunctionName: merged?.user_function?.user_label,
                    transitSeconds: data.transit_seconds,
                    statusDisplayText: data.status_display_text,
                    timeStart: data.time_start,
                });
                setActiveFunctionId(data.hkuserfunctions_id);
                setNextFunctionId(data.next_hkuserfunctions_id);
                setIsAccepted(false);
                setNextSegment(data.user_function_name);
                setTimer(data.time_start);
            } else if (!ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST) {
                toast.error("Failed to fetch the next room");
            }

            updateVarianceFromResponse(merged);
        } catch (error) {
            if (ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST) {
                const merged = mergeProcessRoomCardTestPayload(null);
                setInitData(merged);
                setFunction_time_segment(merged?.function_time_segment || {});
                const data = merged.nbr;
                setRoomData({
                    fromRoom: Number(data.from_room_number),
                    toRoom: Number(data.to_room_number),
                    roomType: data.room_type_code,
                    roomTypeName: data.room_type_name,
                    userFunctionName: merged?.user_function?.user_label,
                    transitSeconds: data.transit_seconds,
                    statusDisplayText: data.status_display_text,
                    timeStart: data.time_start,
                });
                setIsStarted(false);
                setIsAccepted(false);
                setHkfunctiontimesegments_id(merged?.function_time_segment?.hkfunctiontimesegments_id);
                setFtsIdOut(merged?.function_time_segment?.hkfunctiontimesegments_id);
                updateVarianceFromResponse(merged);
                return;
            }
            toast.error("Failed to fetch the next room");
        }
    };

    // Start cleaning handler
    const handleStart = async () => {
        setLoading(true);
        try {
            const response = await nbrApi.post("/getnextuserfunction", {
                properties_id: propertiesId,
                resources_id: resourcesId,
                shiftsegments_id: initData?.params?.shiftsegments_id || Number(ss_id),
                // hkfunctionrequests_id: initData?.user_function?.hkuserfunctions_id ? initData?.user_function?.hkuserfunctions_id : 0,
                hkfunctiontimesegments_id: hkfunctiontimesegments_id,
                timeclocksegments_id: tcs_id ? tcs_id : nextShift?.tcs_id_active,
                hkfunctionrequests_id: initData?.user_function?.hkfunctionrequests_id,
                roles_id: roleId,
                role_name: roleName
            });

            const data = response?.data?.room_statuses;
            if (response?.data?.function_time_segment?.hkfunctiontimesegments_id) {
                setHkfunctiontimesegments_id(response?.data?.function_time_segment?.hkfunctiontimesegments_id)
            }
            setStartData(response?.data)
            setFunction_time_segment(response?.data?.function_time_segment || {})

            if (data) {
                // setRoomData((prev) => ({
                //     ...prev,
                //     timeStart: data.time_start,
                // }));
                setIsAccepted(false);
                setIsStarted(true);
                
                // Update variance from API response
                updateVarianceFromResponse(response?.data);
            } else {
                toast.error("Failed to fetch the next room");
            }
        } catch (error) {
            toast.error("Failed to fetch the next room");
        } finally {
            setLoading(false);
        }
    };

    // Start cleaning handler
    const handleStop = async () => {
        // await handleStart()
        // await getInitData()
        setLoading(true);
        try {
            const response = await nbrApi.post("/getnextuserfunction", {
                properties_id: propertiesId,
                resources_id: resourcesId,
                shiftsegments_id: initData?.params?.shiftsegments_id || Number(ss_id),
                // hkfunctionrequests_id: initData?.user_function?.hkuserfunctions_id ? initData?.user_function?.hkuserfunctions_id : 0,
                // hkfunctiontimesegments_id: initData?.user_function?.time_segment?.hkfunctiontimesegments_id,
                timeclocksegments_id: tcs_id ? tcs_id : nextShift?.tcs_id_active,
                hkfunctionrequests_id: initData?.user_function?.hkfunctionrequests_id,
                hkfunctiontimesegments_id: hkfunctiontimesegments_id,
                roles_id: roleId,
                role_name: roleName
            });
            if (response?.data?.function_time_segment?.hkfunctiontimesegments_id) {
                setHkfunctiontimesegments_id(response?.data?.function_time_segment?.hkfunctiontimesegments_id)
            }
            if (response?.data?.room_statuses?.end_of_process === -1) {
                return await getInitData(response?.data?.function_time_segment?.hkfunctiontimesegments_id)
            }

            const data = response?.data?.room_statuses;

            setIsStarted(false);

            setStartData(response?.data)
            setFunction_time_segment(response?.data?.function_time_segment || {})
            
            // Update variance from API response
            updateVarianceFromResponse(response?.data);

            // if (data) {
            //     // setRoomData((prev) => ({
            //     //     ...prev,
            //     //     timeStart: data.time_start,
            //     // }));
            //     setIsAccepted(false);
            //     setIsStarted(true)
            // } else {
            //     toast.error("Failed to fetch the next room");
            // }
        } catch (error) {
            toast.error("Failed to fetch the next room");
        } finally {
            setLoading(false);
        }
    };

    const applyCartLocation = (data) => {
        const cartData = parseCartLocationResponse(data);
        if (cartData?.floor != null && cartData?.room_number != null) {
            setCartLocation(getFloorName(cartData.floor) + ' (' + cartData.room_number + ')');
            setSelectedFloor(cartData.floor);
            setSelectedRoom(cartData.room_number);
        }
        return cartData;
    };

    const refreshCartLocation = async () => {
        if (!selectedLoginData?.properties_id || !selectedData?.resources_id) return null;
        try {
            const res = await nbrApi.post('/getcartlocation', {
                properties_id: selectedLoginData.properties_id,
                resources_id: selectedData.resources_id,
            });
            return applyCartLocation(res?.data);
        } catch (error) {
            console.error("Error fetching cart location:", error);
            return null;
        }
    };

    // Prefetch cart location so the exit modal opens with floor/room already set
    useEffect(() => {
        refreshCartLocation();
    }, [selectedLoginData?.properties_id, selectedData?.resources_id]);

    const openCartModal = async () => {
        await refreshCartLocation();
        setShowCartModal(true);
    };

    // decline
    const handleDecline = async (isBottom = false) => {
        try {
            setLoading(true);
            // First, notify backend that the request is declined
            const res = await nbrApi.post("/respondtofunctionrequest", {
                // Common identifiers
                properties_id: propertiesId,
                resources_id: resourcesId,
                p_id: propertiesId,
                re_id: resourcesId,
                // Request identifiers
                hkfunctionrequests_id: initData?.user_function?.hkfunctionrequests_id,
                hkrq_id: initData?.user_function?.hkfunctionrequests_id,
                // Session context
                shiftsegments_id: Number(ss_id),
                timeclocksegments_id: tcs_id ? tcs_id : nextShift?.tcs_id_active,
                roles_id: roleId,
                role_name: roleName,
                // Outcome
                response: "declined",
                response_name: "declined",
                hkrc_id: 3,
                fts_id_out: ftsIdOut
            });

            if (res?.data) {
                setFtsIdOut(res?.data?.function_time_segment?.hkfunctiontimesegments_id)
                // Update variance from API response
                updateVarianceFromResponse(res?.data);
            }
            // if (isBottom) {
            //     setShowMenu(false);
            //     setShowCartModal(true);
            // } else {
            // Then, present the popup buttons (Next request or Quit)
            await Swal.fire({
                icon: 'question',
                title: 'Request declined',
                html: `<strong>What would you like to do next?</strong>`,
                showConfirmButton: true,
                confirmButtonText: 'Next Request',
                showCancelButton: true,
                cancelButtonText: roleName === 'room inspector' ? 'Quit Inspection' : 'Stop Cleaning',
                allowOutsideClick: false,
                allowEscapeKey: false,
                backdrop: true,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await getInitData();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    await openCartModal();
                }
            });
            // }

        } catch (error) {
            toast.error("Failed to decline the request.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // handleStart()
        getInitData();
    }, []);


    let functionSegments = function_time_segment || {};

    const progressData = [
        // { label: "REQUEST RESPONSE", key: "seconds_request_response" },
        // { label: "ENTER ROOM", key: "seconds_enter_room" },
        { label: "CLEANING", key: "seconds_clean" },
        // { label: "INSPECTION", key: "seconds_inspect" },
    ];


    return (
        // roomData?.fromRoom === roomData?.toRoom ? <></> :
        <div className="container text-center room-cleaning">
            {ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST && (
                <div className="alert alert-warning py-2 px-3 small mb-3 text-center" role="status">
                    Process door layout test: mock room 405 (<code>ENABLE_PROCESS_ROOM_CARD_LAYOUT_TEST</code> is true in ProcessMode.js)
                </div>
            )}
            {/* Today's Net Variance Display */}
            <div className="border p-2 rounded mb-3" style={{ 
                backgroundColor: todayVariance !== null && todayVariance < 0 ? '#d4edda' : todayVariance !== null && todayVariance > 0 ? '#f8d7da' : '#f0f0f0',
                borderColor: todayVariance !== null && todayVariance < 0 ? '#c3e6cb' : todayVariance !== null && todayVariance > 0 ? '#f5c6cb' : '#dee2e6'
            }}>
                <div className="d-flex justify-content-center align-items-center">
                    <span className="fw-bold" style={{ 
                        fontSize: '1.1rem',
                        color: todayVariance !== null && todayVariance < 0 ? '#155724' : todayVariance !== null && todayVariance > 0 ? '#721c24' : '#333'
                    }}>
                        {todayVariance !== null && todayVariance !== undefined ? (
                            <>
                                {formatVariance(todayVariance)}
                                <span className="ms-2" style={{ fontSize: '0.85rem' }}>
                                    {todayVariance < 0 ? '(ahead)' : todayVariance > 0 ? '(behind)' : '(On Time)'}
                                </span>
                            </>
                        ) : (
                            '--'
                        )}
                    </span>
                </div>
            </div>

            {/* Top Section */}
            <div className="border p-3 rounded">
                <h4 className="text-uppercase fw-bold mb-3 fs-3 text-white py-2 bg-secondary">
                    {currentShift} Mode
                    {/* roomData.statusDisplayText ||  */}
                </h4>
                {/* <span className="fw-bold text-uppercase fs-3 text-black" style={{ color: '#171717' }}>
                    {!isAccepted ? "New Request" : "Accepted Request"}
                </span> */}
            </div>

            {/* Info Section */}
            {/* {!isAccepted && !isStarted && <div className="border p-3">
                <h5 className="text-uppercase fw-bold fs-3 text-primary">
                    {isStarted ? acceptedData?.user_function?.user_label + ' in Process' : (roomData.userFunctionName || nextSegment)}
                </h5>

                <div className="text-medium mb-3 fs-4 text-black mt-5">
                    {roomData.roomTypeName && (
                        <p className="mt-2">{roomData.roomTypeName}</p>
                    )}
                    <p className="mb-0 fs-1 fw-bolder mt-0 text-secondary text-capitalize" style={{ color: '#171717' }}>
                        {(roomData?.fromRoom || roomData?.toRoom) && (!isAccepted ? showFloor(roomData.fromRoom) : showRoom(roomData.toRoom))}
                    </p>
                    {roomData.transitSeconds > 0 && (
                        <p className="mb-0 mt-2">
                            Estimated Transit Time: {roomData.transitSeconds} seconds
                        </p>
                    )}
                </div>
            </div>} */}
            {/* Progress Bar */}
            <div className="mx-auto text-center" style={{ width: 300 }}>
                <div className="d-flex align-items-center justify-content-center gap-3">
                    {progressData?.map(({ label, key }) => (
                        functionSegments[key] !== undefined && (
                            <div className="w-100">
                                <FunctionProgressBar
                                    key={key}
                                    label={label}
                                    timeStart={Date.now() - (functionSegments?.[key] || functionSegments?.['seconds_request_response'] || 0)}
                                    functionSecondsAllocated={functionSegments.function_seconds_allocated || 0}
                                    isDark={true}
                                />
                            </div>
                        )
                    ))}
                </div>
            </div>
            {/* requested */}
            {
                !isAccepted && !isStarted &&
                renderProcessDoorCard({
                    data: initData?.nbr,
                    roomNumber: showFloor(initData?.nbr?.room_number),
                    status: initData?.nbr?.status_display_text,
                    statusColor: initData?.nbr?.status_display_backcolor || '#E10172',
                    room_statuses: initData?.room_statuses
                })
            }

            {/* accepted */}
            {
                isAccepted && !isStarted &&
                renderProcessDoorCard({
                    data: acceptedData?.nbr,
                    roomNumber: acceptedData?.nbr?.room_number,
                    status: `${acceptedData?.user_function?.user_label} accepted`,
                    statusColor: acceptedData?.nbr?.status_display_backcolor || '#E10172',
                    room_statuses: acceptedData?.room_statuses
                })
            }

            {/* started */}
            {
                !isAccepted && isStarted &&
                renderProcessDoorCard({
                    data: startData?.nbr,
                    roomNumber: startData?.nbr?.room_number,
                    status: `${startData?.params?.response_comments} in process`,
                    statusColor: '#E10172',
                    room_statuses: startData?.room_statuses
                })
            }



            {/* Action Buttons */}
            {roomData?.toRoom && // (roomData?.fromRoom !== roomData?.toRoom) 
                <div className="d-flex justify-content-center gap-3 align-items-center">
                    {(!isAccepted && !isStarted) ? (
                        <>
                            <CircleButton
                                backgroundColor="#48BAC8"
                                onClick={handleAcceptRequest}
                                content={<span className="text-capitalize fs-3">Accept</span>}
                                loading={loading}
                            />
                            <CircleButton
                                backgroundColor="#E0346E"
                                onClick={handleDecline}
                                content={<span className="text-capitalize fs-3">Decline</span>}
                                loading={loading}
                            />
                        </>
                    ) : (
                        isStarted === true ?
                            <CircleButton
                                backgroundColor="#E0346E"
                                onClick={handleStop}
                                content={
                                    roleName === "room inspector" ?
                                        <span className="text-capitalize fs-4 lh16">
                                            Finished <br /> Inspecting
                                        </span> :
                                        <span className="text-capitalize fs-4 lh16">
                                            Finished <br /> Cleaning
                                        </span>
                                }
                                loading={loading}
                            /> :
                            <CircleButton
                                backgroundColor="#48BAC8"
                                onClick={handleStart}
                                content={
                                    roleName === "room inspector" ?
                                        <span className="text-capitalize fs-4 lh16">
                                            Start <br /> Inspecting
                                        </span> :
                                        <span className="text-capitalize fs-4 lh16">
                                            Start <br /> Cleaning
                                        </span>
                                }
                                loading={loading}
                            />
                    )}
                </div>}



            {/* Floating Action Button */}
            {roomData?.toRoom && (roomData?.fromRoom !== roomData?.toRoom) &&
                <div className='bottomMenu'>
                    <BottomMenu
                        showMenu={showMenu}
                        setShowMenu={setShowMenu}
                        onCancel={async () => {
                            setShowMenu(false);
                            await getInitData();
                        }}
                        onQuit={() => {
                            handleDecline(true)
                            // setShowMenu(false);
                            // setShowCartModal(true);
                        }}
                    />
                </div>}
            {/* Cart Location Modal on exit */}
            {showCartModal && (
                <CartLocationManager
                    show={showCartModal}
                    setShow={setShowCartModal}
                    cartLoc={cartLocation}
                    setCartLoc={setCartLocation}
                    floor={selectedFloor}
                    setFloor={setSelectedFloor}
                    room={selectedRoom}
                    setRoom={setSelectedRoom}
                    selectedLoginData={selectedLoginData}
                    selectedData={selectedData}
                    cartIcon={cartIcon}
                    ss_in={ss_id}
                    roleName={roleName}
                    startInSelection={true}
                    status="inactive"
                    onComplete={() => navigate('/dashboard')}
                />
            )}
        </div>
    );
};

export default ProcessMode;

